// エラーモーダル
const ModalError = {
  namespaced: true,

  state: {
    modal: false,
    error: [],
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getError: state => {
      return state.error
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setError(state, error) {
      state.error = error
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setError', item.error)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setError', [])
    },
  },
}

export default ModalError
